import React from "react";
import { Button } from "semantic-ui-react";
import { FORM_SCHEMA_TYPES as TYPES } from "../formSchemaTypes";
import { getZendeskTicketUrl } from "../../../../../../../../constants/endpoints";
import ZendeskIcon from "../../../../../../../../components/Icons/ZendeskIcon/ZendeskIcon";

export const UK_SELECT_VALUES = {
  COUNTRIES_V2: "COUNTRIES_V2",
  UK_SECURITY_QUESTIONS: "UK_SECURITY_QUESTIONS",
};

export const ukSchema = {
  generalInfoSegment: {
    label: "General application information",
    type: TYPES.SEGMENT,
    initialOpen: true,
    data: {
      _id: {
        label: "ID",
      },
      isFullyFilled: {
        label: "Form fully filled",
      },
      applicationType: {
        label: "Application Type",
      },
      mainApplicationId: {
        label: "Main Application ID",
        dependsOn: "applicationType",
        dependantOnValues: ["Secondary"],
      },
      siteId: {
        label: "Referral Site",
      },
      cartSiteId: {
        label: "Purchased from website",
      },
      orderId: {
        label: "Order ID",
      },
      orderIdHistory: {
        label: "Order ID history",
      },
      invoiceEmail: {
        label: "Payment email",
      },
      zendeskId: {
        label: "Zendesk ID",
        type: TYPES.TEXT,
        required: false,
        renderIcon: (propValue, applicant) => (
          <Button
            onClick={() => {
              window.open(
                getZendeskTicketUrl(propValue, applicant?.zendeskInstance),
                "_blank",
                "noopener,noreferrer",
              );
            }}
            style={{ width: 36, height: 36, padding: 0, float: "right" }}
            disabled={!propValue}
          >
            <ZendeskIcon className="zendesk-icon" />
          </Button>
        ),
      },
      submissionEmail: {
        label: "Submission email",
        type: TYPES.TEXT,
      },
      submissionPassword: {
        label: "Submission password",
        type: TYPES.TEXT,
      },
      gclid: {
        label: "Google client ID",
      },
      userLanguage: {
        label: "User form language",
      },
      userCountry: {
        label: "Users IP country",
      },
      salesAgent: {
        label: "Sales Agent",
      },
      salesCoupon: {
        label: "Sales Coupon",
      },
    },
  },
  personal_information: {
    label: "Personal Information",
    type: TYPES.SEGMENT,
    data: {
      userEmail: {
        label: "Email",
        type: TYPES.EMAIL,
        required: true,
      },
      userPhone: {
        label: "Phone number",
        type: TYPES.TEXT,
        required: true,
      },
      firstName: {
        label: "Given name",
        type: TYPES.TEXT,
        required: true,
      },
      lastName: {
        label: "Surname",
        type: TYPES.TEXT,
        required: true,
      },
      birthDate: {
        label: "Date of birth",
        type: TYPES.DATE,
        required: true,
      },
      nationality: {
        label: "Nationality",
        type: TYPES.SELECT,
        required: true,
        values: UK_SELECT_VALUES.COUNTRIES_V2,
      },
      passportNumber: {
        label: "Passport number",
        type: TYPES.TEXT,
        required: true,
      },
      passportIssueCountry: {
        label: "Passport issue country",
        type: TYPES.SELECT,
        required: true,
        values: UK_SELECT_VALUES.COUNTRIES_V2,
      },
      haveOtherNationality: {
        label: "Do you have other nationalities?",
        type: TYPES.BOOLEAN,
      },
      otherNationalities: {
        label: "Other nationality",
        type: TYPES.MULTI_SELECT,
        dependsOn: "haveOtherNationality",
        values: UK_SELECT_VALUES.COUNTRIES_V2,
      },
      haveAJob: {
        label: "Do you have a job?",
        type: TYPES.BOOLEAN,
      },
      jobDetails: {
        label: "Job details",
        type: TYPES.TEXT,
        dependsOn: "haveAJob",
      },
      addressLine1: {
        label: "Address line 1",
        type: TYPES.TEXT,
        required: true,
      },
      addressLine2: {
        label: "Address line 2",
        type: TYPES.TEXT,
        required: false,
      },
      addressLine3: {
        label: "Address line 3",
        type: TYPES.TEXT,
        required: false,
      },
      postalCode: {
        label: "Postal code",
        type: TYPES.TEXT,
        required: true,
      },
      country: {
        label: "Country",
        type: TYPES.SELECT,
        required: true,
        values: UK_SELECT_VALUES.COUNTRIES_V2,
      },
      city: {
        label: "City",
        type: TYPES.TEXT,
        required: true,
      },
      hadACriminalConviction: {
        label:
          "Have you ever had a criminal conviction? Include convictions from any country?",
        type: TYPES.BOOLEAN,
      },
      haveBennInvolvedInExtremismOrWarCrimes: {
        label:
          "Have you ever been involved in, or suspected of any of war crimes, genocide or crimes against humanity, terrorism including support of terrorist groups, supporting extremist groups or expressing extremist views?",
        type: TYPES.BOOLEAN,
      },
    },
  },
  consent_and_declaration: {
    label: "Consent and declaration",
    type: TYPES.SEGMENT,
    data: {
      securityQuestion: {
        label: "Security Question",
        type: TYPES.SELECT,
        required: true,
        values: UK_SELECT_VALUES.UK_SECURITY_QUESTIONS,
      },
      securityAnswer: {
        label: "Security Answer",
        type: TYPES.TEXT,
        required: true,
      },
      signatureOfApplicant: {
        label: "Signature of Applicant",
        type: TYPES.TEXT,
        required: true,
      },
      consentDeclaration: {
        label: "Agree with Consent and Declaration",
        type: TYPES.CHECKBOX,
        required: true,
      },
      termsConditions: {
        label: "Agree with Terms and Conditions",
        type: TYPES.CHECKBOX,
        required: true,
      },
      parental_consent: {
        label: "Personal data confidentiality & protection (if applicable)",
        type: TYPES.NESTED,
        nested: {
          parentGuardianName: {
            label: "Parent/Guardian Name",
            type: TYPES.TEXT,
          },
          parentGuardianSignature: {
            label: "Signature of parent or guardian",
            type: TYPES.TEXT,
          },
        },
      },
    },
  },
};
